import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import {getTs} from '../../../library/dates';
import {getEntranceStatus} from './entranceStatus.utils';

// Returns the entrance ticket state ("today"/"tomorrow").
export function useEntranceStatus() {
    const data = useSelector((s: RootState) => s.eTicket.data);
    const now = getTs();
    const status = getEntranceStatus(data, now);

    // Countdown temporarily disabled — no need to tick every second. To restore, bring back the timer:
    // const [now, setNow] = useState(getTs());
    // useEffect(() => {
    //     if(status.state !== 'countdown')
    //         return;
    //     const id = setInterval(() => setNow(getTs()), 1000);
    //     return () => clearInterval(id);
    // }, []);
    // const remainingSec = status.startSec != null ? Math.max(0, status.startSec - now) : 0;

    return {...status, remainingSec: 0};
}
